export default __webpack_public_path__ + "static/5-f4f339cb2ff03c239e078bf2951222d2.jpeg";